import vendorHelpers from '../../../../../shared/vendorHelpers';
import { TRUEVIEW_ANALYTICS_GROUP_NAMES } from '../../../main/screens/ScreenAdsTrueView/trueViewAnalytics.constants';
import {
  CALCULATED_ECPA,
  CALCULATED_ECPA_IN_LOCAL_CURRENCY,
  CALCULATED_ECPC,
  CALCULATED_ECPC_IN_LOCAL_CURRENCY,
  CALCULATED_ECPI,
  CALCULATED_ECPI_IN_LOCAL_CURRENCY,
  CALCULATED_ECPM,
  CALCULATED_ECPM_IN_LOCAL_CURRENCY,
  CALCULATED_ROAS,
  CALCULATED_ROI,
} from './calculations';

export const REENGAGEMENT_COHORT = 'reengagement_cohort';

export const SK_ADNETWORK_DATASOURCE = 'skadnetwork-valid-messages';
export const SK_ADNETWORK_INVALID_MESSAGES_DATASOURCE = 'skadnetwork-invalid-messages';

export const EO_PAGEVIEW = 'eo_pageview';
export const EO_SMS_SENT = 'eo_sms_sent';
export const EO_BRANCH_CTA_VIEW = 'eo_branch_cta_view';
export const EO_WEB_SESSION_START = 'eo_web_session_start';
export const EO_WEB_TO_APP_AUTO_REDIRECT = 'eo_web_to_app_auto_redirect';
export const EO_DISMISSAL = 'eo_dismissal';

export const EO_INSTALL = 'eo_install';
export const EO_CLICK = 'eo_click';
export const EO_OPEN = 'eo_open';
export const EO_REINSTALL = 'eo_reinstall';
export const EO_IMPRESSION = 'eo_impression';

export const EO_COMMERCE_EVENT = 'eo_commerce_event';
export const EO_CONTENT_EVENT = 'eo_content_event';
export const EO_USER_LIFECYCLE_EVENT = 'eo_user_lifecycle_event';
export const EO_CUSTOM_EVENT = 'eo_custom_event';

export const EO_INSTALL_BLOCKED = 'eo_install_blocked';
export const EO_CLICK_BLOCKED = 'eo_click_blocked';
export const EO_OPEN_BLOCKED = 'eo_open_blocked';
export const EO_REINSTALL_BLOCKED = 'eo_reinstall_blocked';
export const EO_IMPRESSION_BLOCKED = 'eo_impression_blocked';

export const EO_COMMERCE_EVENT_BLOCKED = 'eo_commerce_event_blocked';
export const EO_CONTENT_EVENT_BLOCKED = 'eo_content_event_blocked';
export const EO_USER_LIFECYCLE_EVENT_BLOCKED = 'eo_user_lifecycle_event_blocked';
export const EO_CUSTOM_EVENT_BLOCKED = 'eo_custom_event_blocked';

export const ZEIT_CLICK = 'xx_click';
export const ZEIT_IMPRESSION = 'xx_impression';

export const COST = 'cost';
export const COST_IN_LOCAL_CURRENCY = 'cost_in_app_local_currency';
export const COST_ACTIONS = 'cost_actions';
export const COST_CLICKS = 'cost_clicks';
export const COST_INSTALLS = 'cost_installs';
export const COST_IMPRESSIONS = 'cost_impressions';
export const ECPA = 'eCPA';
export const ECPA_IN_LOCAL_CURRENCY = 'eCPA_in_local_currency';
export const ECPC = 'eCPC';
export const ECPC_IN_LOCAL_CURRENCY = 'eCPC_in_local_currency';
export const ECPI = 'eCPI';
export const ECPI_IN_LOCAL_CURRENCY = 'eCPI_in_local_currency';
export const ECPM = 'eCPM';
export const ECPM_IN_LOCAL_CURRENCY = 'eCPM_in_local_currency';
export const ROAS = 'ROAS';
export const ROI = 'ROI';
export const REVENUE = 'revenue';
export const REVENUE_IN_LOCAL_CURRENCY = 'revenue_in_local_currency';

export const IMPRESSION_CONVERSION_RATE = 'impression_conversion_rate';

// Use plural form for table columns (DASH-1627)
export const CORE_DATASOURCES = {
  [EO_PAGEVIEW]: 'pageviews',
  [EO_SMS_SENT]: 'SMS sent',
  [EO_BRANCH_CTA_VIEW]: 'views',
  [EO_INSTALL]: 'installs',
  [EO_CLICK]: 'clicks',
  [EO_OPEN]: 'opens',
  [EO_REINSTALL]: 'reinstalls',
  [EO_WEB_SESSION_START]: 'web session starts',
  [EO_WEB_TO_APP_AUTO_REDIRECT]: 'web to app redirects',
  [EO_IMPRESSION]: 'impressions',
  [EO_DISMISSAL]: 'journey dismissals',
};

export const STANDARD_DATASOURCES = {
  [EO_COMMERCE_EVENT]: 'commerce event',
  [EO_CONTENT_EVENT]: 'content event',
  [EO_USER_LIFECYCLE_EVENT]: 'user lifecycle event',
  [EO_CUSTOM_EVENT]: 'custom event',
};

export const STANDARD_BLOCKED_DATASOURCES = {
  [EO_COMMERCE_EVENT_BLOCKED]: 'commerce event blocked',
  [EO_CONTENT_EVENT_BLOCKED]: 'content event blocked',
  [EO_USER_LIFECYCLE_EVENT_BLOCKED]: 'user lifecycle event blocked',
  [EO_CUSTOM_EVENT_BLOCKED]: 'custom event blocked',
};

export const COST_DATASOURCE = {
  [COST]: COST,
  [CALCULATED_ECPA]: ECPA,
  [CALCULATED_ECPC]: ECPC,
  [CALCULATED_ECPI]: ECPI,
  [CALCULATED_ECPM]: ECPM,
};

export const COST_IN_LOCAL_CURRENCY_DATASOURCE = {
  [COST_IN_LOCAL_CURRENCY]: COST_IN_LOCAL_CURRENCY,
  [CALCULATED_ECPA_IN_LOCAL_CURRENCY]: ECPA_IN_LOCAL_CURRENCY,
  [CALCULATED_ECPC_IN_LOCAL_CURRENCY]: ECPC_IN_LOCAL_CURRENCY,
  [CALCULATED_ECPI_IN_LOCAL_CURRENCY]: ECPI_IN_LOCAL_CURRENCY,
  [CALCULATED_ECPM_IN_LOCAL_CURRENCY]: ECPM_IN_LOCAL_CURRENCY,
};

export const LOCAL_CURRENCY_CALCULATED_DATASOURCES = [
  REVENUE_IN_LOCAL_CURRENCY,
  COST_IN_LOCAL_CURRENCY,
  CALCULATED_ECPA_IN_LOCAL_CURRENCY,
  CALCULATED_ECPC_IN_LOCAL_CURRENCY,
  CALCULATED_ECPI_IN_LOCAL_CURRENCY,
  CALCULATED_ECPM_IN_LOCAL_CURRENCY,
];

export const REVENUE_DATASOURCE = {
  [CALCULATED_ROAS]: ROAS,
  [CALCULATED_ROI]: ROI,
};

export const FRAUD_SPECIFIC_DATASOURCES = {
  [EO_CLICK_BLOCKED]: '#',
  [EO_INSTALL_BLOCKED]: '#',
  [EO_OPEN_BLOCKED]: '#',
  [EO_REINSTALL_BLOCKED]: '#',
  [EO_IMPRESSION_BLOCKED]: '#',
};

export const UNBLOCKED_FRAUD_DATASOURCES = [EO_CLICK, EO_INSTALL, EO_OPEN, EO_REINSTALL, EO_IMPRESSION];

export const ALL_FRAUD_DATASOURCES = [
  ...Object.keys(FRAUD_SPECIFIC_DATASOURCES),
  ...UNBLOCKED_FRAUD_DATASOURCES,

  // commented out standard event datasources because we only wish to show blocked ones in the fraud UI
  // leaving these here for the future in the case that customers wish to see blocked and unblocked standard events
  // Object.keys(STANDARD_DATASOURCES),

  ...Object.keys(STANDARD_BLOCKED_DATASOURCES),
];

export const COHORT_DATASOURCES = {
  [vendorHelpers.VENDOR_DATASOURCES.ARTIFICIAL.INSTALL_COHORT]: 'Acquisition',
  [vendorHelpers.VENDOR_DATASOURCES.ARTIFICIAL.REENGAGEMENT_COHORT]: 'Re-engagement',
};

export const SKAN_DATASOURCES = {
  [SK_ADNETWORK_DATASOURCE]: 'downloads',
  ...TRUEVIEW_ANALYTICS_GROUP_NAMES,
};

export const OTT_DATASOURCES = {
  [IMPRESSION_CONVERSION_RATE]: 'Impression Conversion Rate',
};

/* ------------
 Aggregations
-------------- */
export const DATASOURCES = {
  ...CORE_DATASOURCES,
  ...STANDARD_DATASOURCES,
  ...COST_DATASOURCE,
  ...COST_IN_LOCAL_CURRENCY_DATASOURCE,
  ...REVENUE_DATASOURCE,
};

export const DATASOURCES_IN_DEFAULT_CURRENCY = {
  ...CORE_DATASOURCES,
  ...STANDARD_DATASOURCES,
  ...COST_DATASOURCE,
  ...REVENUE_DATASOURCE,
};

export const CSV_EXPORT_DATASOURCES = {
  ...CORE_DATASOURCES,
  ...STANDARD_DATASOURCES,
  [EO_PAGEVIEW]: 'pageview',
  [EO_SMS_SENT]: 'SMS sent',
  [EO_BRANCH_CTA_VIEW]: 'branch CTA view',
  [EO_DISMISSAL]: 'journey dismissals',
};

/* ------------------------
 PAGE SPECIFIC DATASOURCES
---------------------------
 - Certain tables/charts require a certain set of datasources
 - Eventually add datasources for all tables/charts here for easy viewing and configuration
*/

export const DEEPVIEWS_SUMMARY_SECTION_DATASOURCES = [
  EO_BRANCH_CTA_VIEW,
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL,
];

export const JOURNEYS_SUMMARY_SECTION_DATASOURCES = [
  EO_BRANCH_CTA_VIEW,
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL,
  EO_DISMISSAL,
];

export const JOURNEYS_ANALYTICS_DATASOURCES = [
  EO_BRANCH_CTA_VIEW,
  EO_CLICK,
  EO_COMMERCE_EVENT,
  EO_CONTENT_EVENT,
  EO_CUSTOM_EVENT,
  EO_DISMISSAL,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL,
  EO_SMS_SENT,
  EO_USER_LIFECYCLE_EVENT,
  EO_WEB_SESSION_START,
  EO_WEB_TO_APP_AUTO_REDIRECT,
];

export const CLICK_FLOW_DATASOURCES = [
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_SMS_SENT,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL,
];

export const ATTRIBUTED_TOUCH_DATASOURCES = [
  EO_CLICK,
  EO_WEB_TO_APP_AUTO_REDIRECT,
  EO_SMS_SENT,
  EO_IMPRESSION,
  EO_BRANCH_CTA_VIEW,
  EO_DISMISSAL,
  COST,
  COST_IN_LOCAL_CURRENCY,
];

export const EMAIL_ANALYTICS_DATASOURCES = [
  EO_CLICK,
  EO_COMMERCE_EVENT,
  EO_CONTENT_EVENT,
  EO_CUSTOM_EVENT,
  EO_INSTALL,
  EO_OPEN,
  EO_REINSTALL,
  EO_SMS_SENT,
  EO_USER_LIFECYCLE_EVENT,
  EO_WEB_SESSION_START,
  EO_WEB_TO_APP_AUTO_REDIRECT,
];

export const SEO_DATASOURCES = [
  EO_PAGEVIEW,
  EO_BRANCH_CTA_VIEW,
  EO_INSTALL,
  EO_CLICK,
  EO_OPEN,
  EO_REINSTALL,
  EO_WEB_SESSION_START,
  EO_COMMERCE_EVENT,
  EO_CONTENT_EVENT,
  EO_USER_LIFECYCLE_EVENT,
  EO_CUSTOM_EVENT,
];

export const TRUEVIEW_COLUMNS_DATASOURCES = [EO_CLICK, EO_CUSTOM_EVENT, COST, CALCULATED_ROI, CALCULATED_ROAS];

export const TRUEVIEW_FILTERS_DATASOURCES = [
  EO_INSTALL,
  EO_CLICK,
  EO_OPEN,
  EO_REINSTALL,
  EO_COMMERCE_EVENT,
  EO_CONTENT_EVENT,
  EO_USER_LIFECYCLE_EVENT,
  EO_CUSTOM_EVENT,
  COST,
  CALCULATED_ROI,
  CALCULATED_ROAS,
];
